<template>
  <div class="analysis" >
    <el-row class="mb20">
      <el-col :span="24">
        <el-card>
          <el-row class='text-c'>
            <el-col :span="24">
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="orderDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOrderOptions"
                @change="orderTrend">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="orderbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <el-select
                v-model="searchForm.serveConsult"
                filterable
                remote
                reserve-keyword
                placeholder="请选择服务顾问"
                size="mini"
                clearable
                :loading="searchLoading"
                @change="orderServeConsult"
              >
                <el-option
                  v-for="searchServeConsult in serveConsult"
                  :key="searchServeConsult.id"
                  :label="searchServeConsult.username"
                  :value="searchServeConsult.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="searchForm.serveConsultDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOrderServeOptions"
                @change="orderServeConsult">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="statusbox"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <el-select
                v-model="searchSwitchForm.serveSwitchConsult"
                filterable
                remote
                reserve-keyword
                placeholder="请选择转化顾问"
                size="mini"
                clearable
                :loading="searchLoading"
                @change="orderServeSwitchConsult"
              >
                <el-option
                  v-for="searchServeConsult in serveConsult"
                  :key="searchServeConsult.id"
                  :label="searchServeConsult.username"
                  :value="searchServeConsult.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="searchSwitchForm.serveSwitchConsultDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOrderServeSwitchOptions"
                @change="orderServeSwitchConsult">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="regTypebox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <el-select
                v-model="searchSourceForm.orderSource"
                filterable
                remote
                reserve-keyword
                placeholder="请选择订单来源"
                size="mini"
                clearable
                :loading="searchLoading"
                @change="orderSource"
              >
                <el-option
                  v-for="orderSource in orderPlatform"
                  :key="orderSource.id"
                  :label="orderSource.name"
                  :value="orderSource.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="searchSourceForm.orderSourceDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOrderSourceOptions"
                @change="orderSource">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="chartbox"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <el-select
                v-model="searchDownCertStructForm.downCertConsult"
                filterable
                remote
                reserve-keyword
                placeholder="请选择顾问"
                size="mini"
                clearable
                :loading="searchLoading"
                @change="downCert"
              >
                <el-option
                  v-for="searchServeConsult in serveConsult"
                  :key="searchServeConsult.id"
                  :label="searchServeConsult.username"
                  :value="searchServeConsult.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="searchDownCertStructForm.downCertDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerDownCertOptions"
                @change="downCert">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="downcertstructbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="settledParkDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerSettledParkOptions"
                @change="settledPark">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="settledparkbox"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <div style="height: .54rem"></div>
            </el-col>
          </el-row>
          <div class="charBox" ref="funnelbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="24">
        <el-card>
          <el-row class='text-c'>
            <el-col :span="24">
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="orderDownCertDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerDownCertStateOptions"
                @change="orderDownCertState">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="downcertbox"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/toolbox')
require('echarts/lib/chart/themeRiver')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
// require('echarts/lib/component/visualMap')
export default {
  name: 'OrderRegister',
  data () {
    return {

      orderPark: '',
      curDate: '',
      orderDate: '',
      orderDownCertDate: '',
      orderSourceDate: '',
      settledParkDate: '',
      orderChart: null,
      chart: null,
      orderStatusChart: null,
      proxyChart: null,
      settledParkChart: null,
      OrderRegServeChart: null,
      orderDownCertChart: null,
      orderDownCertStructChart: null,
      orderDay: [],
      orderDayCount: [],
      autoOrderDayCount: [],
      orderTotal: 0,
      orderStatusCount: [],
      orderStatusCountHeader: [],
      orderStatusTotal: 0,
      proxyHeader: [],
      proxyCount: [],
      proxyTotal: 0,
      orderComRegHeader: [],
      orderComRegTotal: 0,
      orderComRegCount: [],
      orderComRegServeHeader: [],
      orderComRegServeTotal: 0,
      orderComRegServeCount: [],
      settledParkCount: [],
      settledParkCountTotal: 0,
      settledParkCountHeader: [],
      orderDownCertTotal: 0,
      orderDownCertCount: [],
      orderDownCertDay: [],
      orderDownCertStructHeader: [],
      orderDownCertStructTotal: 0,
      orderDownCertStructCount: [],
      searchForm: {
        serveConsult: '',
        serveConsultDate: ''
      },
      searchSwitchForm: {
        serveSwitchConsult: '',
        serveSwitchConsultDate: ''
      },
      searchSourceForm: {
        orderSource: '',
        orderSourceDate: ''
      },
      searchDownCertStructForm: {
        downCertConsult: '',
        downCertDate: ''
      },
      searchLoading: false,
      // 人员
      serveConsult: [],
      // 订单来源
      orderPlatform: [],
      pickerOrderOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      pickerOrderServeOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      pickerOrderServeSwitchOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      pickerOrderSourceOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      pickerSettledParkOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      pickerDownCertOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      pickerDownCertStateOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  watch: {
    orderStatusCount (val) {
      this.initCharts()
    },
    proxyCount (val) {
      this.initCharts()
    },
    orderDayCount (val) {
      this.initOrderChar()
    },
    autoOrderDayCount (val) {
      this.initOrderChar()
    },
    settledParkCount (val) {
      this.initSettledParkChart()
    },
    orderComRegCount (val) {
      this.initCharts()
    },
    orderDownCertStructCount () {
      this.initCharts()
    },
    orderDownCertCount () {
      this.initCharts()
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getAnalysisData () {
      this.$axios.post('/api/get_order_state')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            // 订单趋势
            this.orderDayCount = data.data.ordersCount.imOrderCount
            this.autoOrderDayCount = data.data.ordersCount.autoOrderCount
            this.orderTotal = data.data.ordersCount.total
            this.orderDay = data.data.ordersCount.day
            // 服务顾问
            this.orderStatusTotal = data.data.statusCount.total
            this.orderStatusCount = data.data.statusCount.statusCount
            this.orderStatusCountHeader = data.data.statusCount.header
            // 转化顾问
            this.proxyHeader = data.data.switchConsultant.switchConsultantHeader
            this.proxyCount = data.data.switchConsultant.switchConsultantCount
            this.proxyTotal = data.data.switchConsultant.total
            // 云上公司注册订单来源
            this.orderComRegHeader = data.data.orderCompanyReg.orderComRegHeader
            this.orderComRegTotal = data.data.orderCompanyReg.orderComRegTotal
            this.orderComRegCount = data.data.orderCompanyReg.orderComRegCount
            // 云上公司注册服务进度
            this.orderComRegServeHeader = data.data.orderComRegServe.orderComRegServeHeader
            this.orderComRegServeTotal = data.data.orderComRegServe.orderComRegServeTotal
            this.orderComRegServeCount = data.data.orderComRegServe.orderComRegServeCount
            // 云上公司下证进度
            this.orderDownCertCount = data.data.ordersDownCert.orderDownCertCount
            this.orderDownCertTotal = data.data.ordersDownCert.orderDownCertTotal
            this.orderDownCertDay = data.data.ordersDownCert.orderDownCertDay
            // 下证订单构成
            this.orderDownCertStructHeader = data.data.ordersDownCertStruct.orderDownCertStructHeader
            this.orderDownCertStructTotal = data.data.ordersDownCertStruct.orderDownCertStructTotal
            this.orderDownCertStructCount = data.data.ordersDownCertStruct.orderDownCertStructCount
            // 入驻园区
            this.settledParkCountHeader = data.data.orderSettledPark.settledParkCountHeader
            this.settledParkCountTotal = data.data.orderSettledPark.settledParkCountTotal
            this.settledParkCount = data.data.orderSettledPark.settledParkCount
            // 搜索参数
            this.serveConsult = data.data.serveConsult
            this.orderPlatform = data.data.orderPlatform
            this.orderDate = ''
            this.searchForm.serveConsultDate = ''
            this.searchForm.serveConsult = ''
            this.orderDownCertDate = ''
            this.searchSwitchForm.serveSwitchConsultDate = ''
            this.searchSwitchForm.serveSwitchConsult = ''
            this.searchSourceForm.orderSourceDate = ''
            this.searchSourceForm.orderSource = ''
            this.settledParkDate = ''
            this.searchDownCertStructForm.downCertDate = ''
            this.searchDownCertStructForm.downCertConsult = ''
          }
        })
    },
    initCharts () {
      this.chart = echarts.init(this.$refs.chartbox, 'light')
      this.setOption1()
      this.orderStatusChart = echarts.init(this.$refs.statusbox, 'light')
      this.setStatusbox()
      this.proxyChart = echarts.init(this.$refs.regTypebox, 'light')
      this.setProxyType()
      this.OrderRegServeChart = echarts.init(this.$refs.funnelbox, 'light')
      this.setOrderRegServe()
      this.orderDownCertChart = echarts.init(this.$refs.downcertbox, 'light')
      this.setOrderDownCert()
      this.orderDownCertStructChart = echarts.init(this.$refs.downcertstructbox, 'light')
      this.setOrderDownCertStruct()
    },
    initOrderChar () {
      this.orderChart = echarts.init(this.$refs.orderbox, 'light')
      this.setOrderOption()
    },
    initSettledParkChart () {
      this.settledParkChart = echarts.init(this.$refs.settledparkbox, 'light')
      this.setSettledParkOption()
    },
    // 云上公司注册订单趋势
    setOrderOption () {
      let option = {
        title: {
          text: '云上公司注册订单趋势（' + this.orderTotal + '）'
          // left: 'center'
        },
        legend: {
          data: ['自主自助', 'IM转化']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          boundaryGap: false,
          type: 'category',
          data: this.orderDay
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '自主自助',
            type: 'line',
            stack: 'Total',
            data: this.autoOrderDayCount
          },
          {
            name: 'IM转化',
            type: 'line',
            stack: 'Total',
            data: this.orderDayCount
          }
        ]
      }
      option && this.orderChart.setOption(option)
    },
    setOrderDownCert () {
      let option = {
        title: {
          text: '云上公司下证进度（' + this.orderDownCertTotal + '）'
        },
        legend: {
          data: ['云上公司下证进度']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          boundaryGap: false,
          type: 'category',
          data: this.orderDownCertDay
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '云上公司下证进度',
            type: 'line',
            stack: 'Total',
            data: this.orderDownCertCount
          }
        ]
      }
      option && this.orderDownCertChart.setOption(option)
    },
    // 订单来源
    setOption1 () {
      let option = {
        title: {
          text: '云上注册订单来源（' + this.orderComRegTotal + '）',
          left: 'left',
          top: 'top',
          textStyle: {
            fontSize: 16
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.orderComRegHeader
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        series: [
          {
            name: '云上注册订单来源',
            type: 'pie',
            radius: ['40%', '70%'],
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.orderComRegCount,
            color: ['#C8E0FF', '#5787FF', '#FFD8B4', '#AEA1FB', '#E37C7C']
          }
        ]
      }
      option && this.chart.setOption(option)
    },
    // 服务顾问
    setStatusbox () {
      let option = {
        title: {
          text: '服务顾问（' + this.orderStatusTotal + '）',
          left: 'left',
          top: 'top',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.orderStatusCountHeader
        },
        series: [
          {
            name: '服务顾问',
            type: 'pie',
            radius: ['40%', '70%'],
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.orderStatusCount,
            color: ['#C8E0FF', '#5787FF', '#FFD8B4', '#AEA1FB', '#E37C7C']
          }
        ]
      }
      option && this.orderStatusChart.setOption(option)
    },
    setOrderRegServe () {
      let option = {
        title: {
          text: '云上注册服务进度',
          left: 'right',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}%'
        },
        legend: {
          left: 'left',
          data: this.orderComRegServeHeader
        },
        series: [
          {
            name: '云上注册服务进度',
            type: 'funnel',
            left: '10%',
            top: 60,
            bottom: 40,
            width: '80%',
            min: 0,
            max: 100,
            minSize: '0%',
            maxSize: '100%',
            sort: 'descending',
            gap: 2,
            label: {
              show: true,
              position: 'inside'
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid'
              }
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            },
            data: this.orderComRegServeCount
          }
        ]
      }
      option && this.OrderRegServeChart.setOption(option)
    },
    // 转化顾问
    setProxyType () {
      let option = {
        title: {
          text: '转化顾问（' + this.proxyTotal + '）',
          left: 'right',
          top: 'top',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.proxyHeader
        },
        series: [
          {
            name: '转化顾问（',
            type: 'pie',
            radius: ['40%', '70%'],
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.proxyCount,
            color: ['#C8E0FF', '#5787FF', '#FFD8B4', '#AEA1FB', '#E37C7C']
          }
        ]
      }
      this.proxyChart.setOption(option)
    },
    // 入驻园区
    setSettledParkOption () {
      let option = {
        title: {
          text: '入驻园区',
          left: 'left',
          top: 'top',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.settledParkCountHeader
        },
        series: [
          {
            name: '入驻园区',
            type: 'pie',
            radius: ['40%', '70%'],
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.settledParkCount,
            color: ['#C8E0FF', '#5787FF', '#FFD8B4', '#AEA1FB', '#E37C7C']
          }
        ]
      }
      option && this.settledParkChart.setOption(option)
    },
    // 下证订单构成
    setOrderDownCertStruct () {
      let option = {
        title: {
          text: '下证订单构成（' + this.orderDownCertStructTotal + '）',
          left: 'right',
          top: 'top',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.orderDownCertStructHeader
        },
        series: [
          {
            name: '下证订单构成',
            type: 'pie',
            radius: ['40%', '70%'],
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.orderDownCertStructCount,
            color: ['#C8E0FF', '#5787FF', '#FFD8B4', '#AEA1FB', '#E37C7C']
          }
        ]
      }
      option && this.orderDownCertStructChart.setOption(option)
    },
    // 订单趋势
    orderTrend (val) {
      this.$axios.post('/api/admin/tyc_order/order_trend', {val: val})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderDayCount = data.data.ordersCount.imOrderCount
            this.autoOrderDayCount = data.data.ordersCount.autoOrderCount
            this.orderDay = data.data.ordersCount.day
            this.orderTotal = data.data.ordersCount.total
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 服务顾问
    orderServeConsult () {
      this.$axios.post('/api/admin/tyc_order/order_serve_consultant', {val: this.searchForm})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderStatusTotal = data.data.statusCount.total
            this.orderStatusCount = data.data.statusCount.statusCount
            this.orderStatusCountHeader = data.data.statusCount.header
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 转化顾问
    orderServeSwitchConsult () {
      this.$axios.post('/api/admin/tyc_order/order_serve_switch_consultant', {val: this.searchSwitchForm})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.proxyHeader = data.data.switchConsultant.switchConsultantHeader
            this.proxyCount = data.data.switchConsultant.switchConsultantCount
            this.proxyTotal = data.data.switchConsultant.total
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 订单来源
    orderSource () {
      this.$axios.post('/api/admin/tyc_order/order_source', {val: this.searchSourceForm})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderComRegHeader = data.data.orderCompanyReg.orderComRegHeader
            this.orderComRegTotal = data.data.orderCompanyReg.orderComRegTotal
            this.orderComRegCount = data.data.orderCompanyReg.orderComRegCount
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 入驻园区
    settledPark (val) {
      this.$axios.post('/api/admin/tyc_order/settled_park', {val: val})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.settledParkCountHeader = data.data.orderSettledPark.settledParkCountHeader
            this.settledParkCountTotal = data.data.orderSettledPark.settledParkCountTotal
            this.settledParkCount = data.data.orderSettledPark.settledParkCount
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 下证订单构成
    downCert () {
      this.$axios.post('/api/admin/tyc_order/down_cert_struct', {val: this.searchDownCertStructForm})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderDownCertStructHeader = data.data.ordersDownCertStruct.orderDownCertStructHeader
            this.orderDownCertStructTotal = data.data.ordersDownCertStruct.orderDownCertStructTotal
            this.orderDownCertStructCount = data.data.ordersDownCertStruct.orderDownCertStructCount
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 下证进度
    orderDownCertState (val) {
      this.$axios.post('/api/admin/tyc_order/down_cert_state', {val: val})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderDownCertCount = data.data.ordersDownCert.orderDownCertCount
            this.orderDownCertTotal = data.data.ordersDownCert.orderDownCertTotal
            this.orderDownCertDay = data.data.ordersDownCert.orderDownCertDay
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.getAnalysisData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .clearfix:before,
  .clearfix:after
    display: table
    content: ""
  .text-r
    text-align: center
  .text-c
    text-align: right
  .analysis
    marginLeft()
    .mb20
      margin-bottom: .4rem
    .charBox
      width: 100%
      height: 6rem
    .cardBox
      height: 2rem
      cursor: pointer
    .cardBoxDiv
      height: 100%
    .cardBoxName
      font-size: .4rem
      font-weight: 400
      line-height: .6rem
    .activeBg
      background-color: #5787FF !important
    .activeBg2
      background-color: #FFC68E !important
    .activeBg3
      background-color: #AEA1FB !important
    .cardColor
      color: #A2A2A2
    .activeCardColor
      color: #FFFFFF
</style>



// WEBPACK FOOTER //
// src/pages/order_register/OrderRegister.vue